import { createFeature, createReducer, on, provideState } from '@ngrx/store';
import { SettingsActions } from './settings.action';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { SettingsEffects } from './settings.effects';
import { Language } from '../../types/enum';
import { Cookies, getCookie } from '../../../utils/cookies';

export const initialState: Readonly<Settings> = {
  notifications: true,
  language: getCookie(Cookies.LANGUAGE) || Language.en,
  fontSize: '1.6rem',
  transcript: '',
};

export const settingsFeature = createFeature({
  name: 'settings',
  reducer: createReducer(
    initialState,
    on(SettingsActions.setLanguageSuccess, (state, { language }) => {
      return { ...state, language };
    }),
    on(SettingsActions.setNotifications, (state, { value }) => {
      return { ...state, notifications: value };
    }),
    on(SettingsActions.setFontSize, (state, { value }) => {
      return { ...state, fontSize: value };
    }),
    on(SettingsActions.setTranscript, (state, { value }) => {
      return { ...state, transcript: value };
    })
  ),
});

export const { selectSettingsState, selectLanguage, selectFontSize } =
  settingsFeature;

export function provideSettingsFeature() {
  return makeEnvironmentProviders([
    provideState(settingsFeature),
    provideEffects(SettingsEffects),
  ]);
}
